import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import CustomHeader from "./CustomHeader";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { api } from "common";
import { colors } from "../components/Theme/WebTheme";
import { MAIN_COLOR, SECONDORY_COLOR } from "../common/sharedFunctions";
import MenuItems from "./MenuItems";

const drawerWidth = 268;

export default function ResponsiveDrawer(props) {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir();
  const [mobileOpen, setMobileOpen] = useState(false);
  const { signOff } = api;
  const auth = useSelector((state) => state.auth);
  const settings = useSelector((state) => state.settingsdata.settings);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [role, setRole] = useState(null);

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  useEffect(() => {
    const auth = getAuth();
    const checkTokenExpiry = () => {
      const expirationTime = auth.currentUser?.stsTokenManager?.expirationTime;
      if (expirationTime && Date.now() >= expirationTime) {
        console.log("Token expired! Logging out...");
        signOut(auth)
          .then(() => {
            dispatch(signOff());
            navigate("/login");
          })
          .catch((error) => {
            console.error("Sign-out error:", error);
          });
      }
    };
    checkTokenExpiry();
    const interval = setInterval(checkTokenExpiry, 60000);
    return () => clearInterval(interval);
  }, [dispatch, navigate, signOff]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawer = () => {
    setMobileOpen(false);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        direction: isRTL === "rtl" ? "rtl" : "ltr",
      }}
    >
      <CssBaseline />
      <style>
        {`
          ::-webkit-scrollbar {
            width: 8px;
          }
          ::-webkit-scrollbar-thumb {
            background-color: ${SECONDORY_COLOR};
            border-radius: 6px;
          }
          ::-webkit-scrollbar-thumb:hover {
            background-color: ${MAIN_COLOR};
          }
          ::-webkit-scrollbar-track {
            background-color: ${colors.WHITE};
          }
        `}
      </style>
      {/* {role === "customer" ? ( */}
      <CustomHeader
        drawerWidth={drawerWidth}
        isRTL={isRTL}
        handleDrawerToggle={handleDrawerToggle}
        settings={settings}
        auth={auth}
      />
      <Box
        component="nav"
        sx={{
          width: { sm: drawerWidth },
          flexShrink: { sm: 0 },
        }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          anchor={isRTL === "rtl" ? "right" : "left"}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              border: "none",
            },
          }}
        >
          <MenuItems role={role} handleDrawer={handleDrawer} />
        </Drawer>
        <Drawer
          variant="permanent"
          anchor={isRTL === "rtl" ? "right" : "left"}
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              border: "none",
            },
          }}
          open
        >
          <MenuItems role={role} handleDrawer={handleDrawer} />
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        {props.children}
      </Box>
    </Box>
  );
}
